import React from 'react'
import CheckStock from './CheckStock'
import CheckStockByState from './CheckStockByState'
import NotifyOutOfStock from './NotifyOutOfStock'

const PopUps = params => {
  const {
    data,
  } = params

  return (
    <>
      <CheckStock data={data} />
      <CheckStockByState />
      <NotifyOutOfStock />
    </>
  )
}

export default PopUps
